import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
function derivePlaybackState(el) {
    if (!el)
        return 'no-media';
    if (el.seeking)
        return 'seeking';
    if (el.paused)
        return 'paused';
    if (el.readyState < 3)
        return 'waiting';
    return 'playing';
}
export default function SyncDebugOverlay({ visible, mediaRef, role, driftMs, syncState, colId, }) {
    const [, setTick] = useState(0);
    const rafRef = useRef(0);
    useEffect(() => {
        if (!visible)
            return;
        const update = () => {
            setTick((t) => t + 1);
            rafRef.current = requestAnimationFrame(update);
        };
        rafRef.current = requestAnimationFrame(update);
        return () => cancelAnimationFrame(rafRef.current);
    }, [visible]);
    if (!visible)
        return null;
    // Read live sync data from the global Map if colId is provided
    let liveDriftMs = driftMs;
    let liveSyncState = syncState;
    if (colId && role === 'follower') {
        const syncData = window.__playerSyncFollowerState?.get(colId);
        if (syncData) {
            liveDriftMs = syncData.driftMs ?? liveDriftMs;
            liveSyncState = syncData.syncState ?? liveSyncState;
        }
    }
    const mediaElement = mediaRef.current;
    const time = mediaElement?.currentTime ?? 0;
    const rate = mediaElement?.playbackRate ?? 1;
    const playback = derivePlaybackState(mediaElement);
    const driftLabel = role === 'source'
        ? '\u2014'
        : liveDriftMs != null
            ? `${liveDriftMs >= 0 ? '+' : ''}${Math.round(liveDriftMs)}ms`
            : '?';
    const stateLabel = role === 'source' ? '\u2014' : liveSyncState ?? '?';
    const style = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        background: 'rgba(0, 0, 0, 0.7)',
        color: '#fff',
        fontFamily: 'monospace',
        fontSize: '11px',
        lineHeight: '18px',
        padding: '2px 8px',
        pointerEvents: 'none',
        display: 'flex',
        gap: '12px',
        whiteSpace: 'nowrap',
    };
    return (_jsxs("div", { "data-testid": "sync-debug-overlay", style: style, children: [_jsx("span", { style: { color: role === 'source' ? '#4fc3f7' : '#aed581' }, children: role === 'source' ? 'SOURCE' : 'FOLLOWER' }), _jsxs("span", { children: ["T:", time.toFixed(3), "s"] }), _jsxs("span", { children: ["Rate:", rate.toFixed(3), "x"] }), _jsxs("span", { children: ["Drift:", driftLabel] }), _jsxs("span", { children: ["Sync:", stateLabel] }), _jsxs("span", { children: ["PB:", playback] })] }));
}
